import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Button,
  CardContent,
  CardActions,
  Grid,
  Card,
  CardMedia,
  IconButton,
  TextField,
  Box,
} from "@mui/material";
import { getUser, getUsers, updateUser } from "../api";
import { Edit } from "@mui/icons-material";
import UserModal from "../components/UserModal";
import Loader from "../components/common/Loader";
import config from "../config";

export default function AdminsPage() {
  const [state, setState] = useState({});

  const usernameOrEmailInputRef = useRef();

  const handleSearch = async () => {
    let data;

    if (usernameOrEmailInputRef.current.value) {
      const user = await getUser(
        usernameOrEmailInputRef.current.value,
        "admin"
      );

      if (user.id) {
        data = [user];
      } else {
        data = [];
      }
    } else {
      data = await getUsers("admin");
    }

    setState((s) => ({
      ...s,
      data,
    }));
  };

  const handleEdit = (item) => () => {
    setState((s) => ({
      ...s,
      open: true,
      user: item,
      handleConfirm: async (body) => {
        const user = await updateUser(body);
        user.timestamp = Date.now();
        s.data.splice(
          s.data.indexOf(s.data.find((x) => x.id === user.id)),
          1,
          user
        );
      },
    }));
  };

  const handleClose = () => {
    setState((s) => ({
      ...s,
      open: false,
      user: undefined,
      handleConfirm: undefined,
    }));
  };

  useEffect(() => {
    (async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        const data = user.role === "admin" ? await getUsers("admin") : [];
        setState((s) => ({
          ...s,
          data,
          role: user.role,
        }));
      }
    })();
  }, []);

  return (
    <>
      <Grid
        container
        spacing={4}
        sx={{ maxWidth: "1600px", paddingTop: "80px", paddingX: 4 }}
        justifyContent={state.data?.length ? "left" : "center"}
      >
        {["admin"].includes(state.role) && (
          <Grid item xs={12}>
            <Card variant="outlined" sx={{ display: "flex", padding: 2 }}>
              <TextField
                autoComplete="off"
                margin="dense"
                id="name"
                label="Username or Email"
                type="text"
                variant="outlined"
                color="secondary"
                size="small"
                inputRef={usernameOrEmailInputRef}
                sx={{ flexGrow: 1, marginRight: 1 }}
                InputProps={{ style: { color: "#d8c8f4" } }}
                InputLabelProps={{ shrink: true }}
              />
              <Button
                type="submit"
                onClick={handleSearch}
                variant="outlined"
                color="secondary"
                size="small"
              >
                Search
              </Button>
            </Card>
          </Grid>
        )}
        {state.data ? (
          <Grid item xs={12}>
            <Typography
              variant="h6"
              sx={{ textAlign: "left", color: "white", marginBottom: "10px" }}
            >
              Admins
            </Typography>
            <Grid container spacing={3}>
              {state.data.map((item) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  xl={2.4}
                  key={item.id}
                  sx={{ background: "transparent" }}
                >
                  <Card
                    variant="outlined"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "#4b445b",
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={
                        item.timestamp
                          ? `${config.cdnUrl}/avatars/${item.id}?t=${item.timestamp}`
                          : `${config.cdnUrl}/avatars/${item.id}`
                      }
                      alt={item.username}
                      sx={{
                        width: 250,
                        height: 250,
                        margin: "5px auto 0px",
                        borderRadius: 1,
                      }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        minWidth: "1px",
                        marginLeft: "10px",
                      }}
                    >
                      <CardContent sx={{ flex: 1 }}>
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="div"
                          color="secondary"
                          noWrap
                        >
                          {item.username}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="secondary"
                          mb={1}
                          noWrap
                        >
                          {item.email}
                        </Typography>
                        <Typography variant="body2" color="secondary" mb={1}>
                          {new Date(item.createdAt).toLocaleString([], {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </Typography>
                      </CardContent>
                      <CardActions>
                        {["admin"].includes(state.role) && (
                          <IconButton
                            aria-label="edit"
                            onClick={handleEdit(item)}
                            color="secondary"
                            sx={{ marginLeft: "auto" }}
                          >
                            <Edit />
                          </IconButton>
                        )}
                      </CardActions>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        ) : (
          <Loader />
        )}
      </Grid>
      {state.open && (
        <UserModal
          venueId={state.venueId}
          user={state.user}
          handleConfirm={state.handleConfirm}
          handleClose={handleClose}
        />
      )}
    </>
  );
}
